import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';

export default function Terms() {
  const { t, language, setLanguage } = useLanguage();
  
  return (
    <div className="min-h-screen bg-[#020617] text-slate-300 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <Link 
            to="/login" 
            className="inline-flex items-center text-slate-400 hover:text-[#D4AF37] transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            {t('login')}
          </Link>
          
          <Select value={language} onValueChange={setLanguage}>
            <SelectTrigger className="w-[140px] border-slate-700 bg-slate-800/50">
              <Globe className="h-4 w-4 mr-2" />
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="en">{t('english')}</SelectItem>
              <SelectItem value="pt">{t('portuguese')}</SelectItem>
              <SelectItem value="fr">{t('french')}</SelectItem>
              <SelectItem value="es">{t('spanish')}</SelectItem>
              <SelectItem value="el">{t('greek')}</SelectItem>
              <SelectItem value="ru">{t('russian')}</SelectItem>
              <SelectItem value="it">{t('italian')}</SelectItem>
            </SelectContent>
          </Select>
        </div>
        
        <div className="glass-card p-8">
          <h1 className="font-heading text-3xl font-bold text-[#D4AF37] mb-6">{t('termsOfService')}</h1>
          <p className="text-slate-400 text-sm mb-8">{t('termsLastUpdated')}: December 2025</p>
          
          <div className="space-y-6 text-slate-300 leading-relaxed">
            <p>{t('termsIntro')}</p>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">1. {t('termsAcceptance')}</h2>
              <p>{t('termsAcceptanceText')}</p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">2. {t('termsUseOfService')}</h2>
              <p>{t('termsUseOfServiceText')}</p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">3. {t('termsUserAccounts')}</h2>
              <p>{t('termsUserAccountsText')}</p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">4. {t('termsIntellectualProperty')}</h2>
              <p>{t('termsIntellectualPropertyText')}</p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">5. {t('termsTermination')}</h2>
              <p>{t('termsTerminationText')}</p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">6. {t('termsLimitation')}</h2>
              <p>{t('termsLimitationText')}</p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">7. {t('termsChanges')}</h2>
              <p>{t('termsChangesText')}</p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">8. {t('termsContact')}</h2>
              <p>{t('termsContactText')}</p>
            </section>
          </div>
        </div>
        
        <p className="text-center mt-8 text-slate-500 text-sm">
          {t('privacyPolicyTitle')}: <Link to="/privacy" className="text-[#D4AF37] hover:underline">{t('privacyPolicy')}</Link>
        </p>
      </div>
    </div>
  );
}
